import { ClipboardDocumentListIcon, CalendarDaysIcon, KeyIcon } from '@heroicons/react/24/outline';

export default function HowItWorks() {
  const steps = [
    {
      icon: ClipboardDocumentListIcon,
      title: "1. Choose Your Vehicle",
      desc: "Browse our exclusive fleet and select the perfect vehicle for your needs.",
    },
    {
      icon: CalendarDaysIcon,
      title: "2. Book Online",
      desc: "Select your dates and complete the booking process with our secure system.",
    },
    {
      icon: KeyIcon,
      title: "3. Pick Up & Drive",
      desc: "Meet us at the agreed location, complete paperwork, and enjoy your ride!",
    },
  ];

  return (
    <section id="how-it-works" className="py-16 bg-gray-100 font-sans">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            How It Works
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Renting your dream car is simple — just follow these three easy steps.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid gap-8 md:grid-cols-3">
          {steps.map((step, i) => (
            <div
              key={i}
              className="bg-white rounded-lg shadow tracking-tight transition-all duration-500 p-6 text-center"
              data-aos="fade-up"
              data-aos-delay={i * 150}
            >
              <step.icon className="w-12 h-12 text-brandBlue mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}